import $ from 'jquery';
import 'gasparesganga-jquery-loading-overlay';

import { Component } from "./ajax-dispatcher";

export default class LoadingIndication{
    static show(element: HTMLElement){
        $(element).LoadingOverlay('show', {
            image: '',
            custom: this.getLoadingIcon()
        });
    }

    private static getLoadingIcon(){
        const loadingIconDiv = $("<div>", {
            "class" : "loading-icon",
        });
        loadingIconDiv.append($("<div>"));
        loadingIconDiv.append($("<div>"));
        loadingIconDiv.append($("<div>"));
        return loadingIconDiv;
    }

    static hide(element: HTMLElement){
        $(element).LoadingOverlay('hide');
    }
}

export class ComponentLoadingIndication{
    private component: Component;
    
    constructor(component: Component){
        this.component = component;
    }

    private getElement(way: 'input'|'output'): HTMLElement{
        if(this.component.id) {
            return document.getElementById(this.component.id);
        }
        return document.querySelector(`[data-component="${this.getComponentName(way)}"]`);
    }

    private getComponentName(way: 'input'|'output'){
        return (way == 'input' && this.component.inputComponent) ? this.component.inputComponent : this.component.outputComponent;
    }

    public show(){
        LoadingIndication.show(this.getElement('input'));
    }

    public hide(){
        LoadingIndication.hide(this.getElement('output'));
    }
}
